import React from 'react';
import { LinkProps } from 'next/link';
import { HorizontalSlider, BlockHeader, TekoLink } from '@teko/teko-ecommerce';
import { styled, LazyImage, ThemeProps, SubTitle } from '@teko/ds-mobile';
import { t } from 'i18n';
import { formatCurrency } from 'helpers';

const Product: React.FC<ProductProps> = (props) => {
  const { price, imageUrl, discountPercent, link } = props;
  const formattedPrice = formatCurrency(parseFloat(price) || '');
  return (
    <TekoLink {...link}>
      <ProductWrapper>
        <LazyImage cover width={64} height={64} src={imageUrl ?? ''} />
        {!!discountPercent && (
          <DiscountPercent>{discountPercent}</DiscountPercent>
        )}
      </ProductWrapper>
      <StyledSubTitle>{formattedPrice}</StyledSubTitle>
    </TekoLink>
  );
};

export const RecentViewedProductsBlock: React.FC<
  RecentViewedProductBlocksProps
> = (props) => {
  const { products = [] } = props;

  if (!products.length) return null;

  return (
    <ProductListWrapper>
      <BlockHeader title={t('Sản phẩm vừa xem')} />
      <HorizontalSlider slidesPerView={4.7}>
        {products.map((product) => (
          <Product
            key={product.sku}
            sku={product.sku}
            price={product.price}
            imageUrl={product.imageUrl}
            discountPercent={product.discountPercent}
            link={product.link}
          />
        ))}
      </HorizontalSlider>
    </ProductListWrapper>
  );
};

export interface ProductProps {
  sku: string;
  price: string;
  link: LinkProps;
  imageUrl?: string;
  discountPercent?: string;
}

interface RecentViewedProductBlocksProps {
  products: ProductProps[];
}

const ProductWrapper = styled.div(
  ({ theme }: ThemeProps) => `
  position: relative;
  text-align: center;
  border: 0.5px solid ${theme?.colors.divider};
  border-radius: 4px;
`,
);

const DiscountPercent = styled.div(
  ({ theme }: ThemeProps) => `
  position: absolute;
  top: 0;
  right: 0;
  color: ${theme?.colors.white};
  background-color: ${theme?.colors.primary500};
  border-radius: 2px;
  font-size: 10px;
  padding: 0 4px;
`,
);

const ProductListWrapper = styled.div`
  width: 100%;
  padding: 8px 16px;
`;

const StyledSubTitle = styled(SubTitle)`
  text-align: center;
`;
